import React, { Component } from "react";

export default class chevron extends Component {
  render() {
    return (
      <svg className={this.props.className} onClick={this.props.onClick} width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.49609 5H5.16276H18.4961" stroke="#D5D4D3" strokeWidth="1.6" stroke-linecap="round" strokeLinejoin="round" />
        <path d="M7.66406 5.0013V3.33464C7.66406 2.89261 7.83966 2.46868 8.15222 2.15612C8.46478 1.84356 8.8887 1.66797 9.33073 1.66797H12.6641C13.1061 1.66797 13.53 1.84356 13.8426 2.15612C14.1551 2.46868 14.3307 2.89261 14.3307 3.33464V5.0013M16.8307 5.0013V16.668C16.8307 17.11 16.6551 17.5339 16.3426 17.8465C16.03 18.159 15.6061 18.3346 15.1641 18.3346H6.83073C6.3887 18.3346 5.96478 18.159 5.65222 17.8465C5.33966 17.5339 5.16406 17.11 5.16406 16.668V5.0013H16.8307Z" stroke="#D5D4D3" strokeWidth="1.6" stroke-linecap="round" strokeLinejoin="round" />
      </svg>

    );
  }
}
